import React from "react";
import { PackageOpen } from "lucide-react";

export const EmptyState = ({ icon: Icon = PackageOpen, title, message, action, testId }) => (
  <div className="flex flex-col items-center justify-center text-center bg-card border border-dashed border-border rounded-3xl py-14 px-6" data-testid={testId || "empty-state"}>
    <span className="h-16 w-16 rounded-2xl bg-[#e7f6ec] dark:bg-[#16341f] flex items-center justify-center mb-4">
      <Icon size={30} className="text-[#16a34a]" />
    </span>
    <h3 className="text-lg font-extrabold text-foreground">{title}</h3>
    {message && <p className="text-sm text-muted-foreground mt-1.5 max-w-sm">{message}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);

export default EmptyState;
